import VisualizarProdutoServico from './VisualizarProdutoServico';

export default VisualizarProdutoServico;
